import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 glass"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-xl bg-slate-900 text-[#D4AF37] grid place-items-center font-heading font-bold text-lg">
            S
          </div>
          <div className="leading-tight">
            <div className="font-heading font-semibold text-slate-900 tracking-tight">Solutions Showroom</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">Enterprise-Grade Systems</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
          <Link to="/" className="hover:text-slate-900 transition-colors" data-testid="nav-home">Home</Link>
          <a href="/#systems" className="hover:text-slate-900 transition-colors" data-testid="nav-systems">Systems</a>
          <a href="/#categories" className="hover:text-slate-900 transition-colors" data-testid="nav-categories">Categories</a>
          <a href="/#contact" className="hover:text-slate-900 transition-colors" data-testid="nav-contact">Contact</a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {!isAdmin && (
                <Button asChild variant="outline" className="rounded-full" data-testid="nav-admin-btn">
                  <Link to="/admin">Admin</Link>
                </Button>
              )}
              <Button onClick={logout} variant="ghost" className="rounded-full" data-testid="nav-logout-btn">
                Logout
              </Button>
            </>
          ) : (
            <Button asChild className="rounded-full bg-slate-900 hover:bg-slate-800" data-testid="nav-request-demo">
              <a href="/#contact">Request Demo</a>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
